import { render, staticRenderFns } from "./LabSelect.vue?vue&type=template&id=f5bd2eb8&"
import script from "./LabSelect.vue?vue&type=script&lang=js&"
export * from "./LabSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports